import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyNajlepszeSneakersy() {
  return <ArticleLayout article={articlesBySlug['kakobuy-najlepsze-sneakersy-2026']} />;
}